'use client';

import { useRouter } from 'next/navigation';

import { useMobileTopBar, useUIOverlay } from '@/shared/hooks';
import { MobileTitleBox } from '@/features/AppBar';

const MobileTopBar = () => {
  const router = useRouter();
  const { title, showBottomDivider } = useMobileTopBar();
  const { handleOpen } = useUIOverlay();

  const openUserMenu = () => handleOpen('userMenu');
  const goBack = () => router.back();

  return (
    <MobileTitleBox
      title={title}
      bottomDivider={showBottomDivider}
      onBackButtonClick={goBack}
      openUserMenu={openUserMenu}
    />
  );
};

export default MobileTopBar;
